import { h, ComponentChild } from 'preact'
import ButtonControl from '../button-control'
import Flag from '../ui-components/Flag'

const reloadPage = () => {
  window.location.reload()
}

interface CustomButton {
  title: string,
  variant: string,
  url?: string,
  customClass?: string,
  nodeName?: string,
  action?: Function | string
}

interface SaveProps1 {
  saveCallback?: undefined,
  disableSaveButton: true,
}

interface SaveProps2 {
  saveCallback?: () => void,
  disableSaveButton?: false,
}

interface Props {
  title: string,
  cancelCallback?: Function,
  isLoading?: boolean,
  hasBreadcrumb?: boolean,
  breadcrumbLink?: string,
  breadcrumbText?: string,
  disableCancelButton?: boolean,
  customButtons?: Array<CustomButton | ComponentChild>,
  statusLabelText?: string,
  statusLabelSuccess?: boolean,
  statusLabelSecondary?: boolean,
  customComponent?: JSX.Element
}

interface Props1 extends Props, SaveProps1 {}
interface Props2 extends Props, SaveProps2 {}

function isComponent(item: CustomButton | ComponentChild): item is ComponentChild {
  return typeof(item) === 'object' && item !== null && ('nodeName' in item)
}

const Header = ({
  title,
  saveCallback = () => {},
  cancelCallback = reloadPage,
  isLoading = false,
  hasBreadcrumb = false,
  breadcrumbLink,
  breadcrumbText,
  disableCancelButton = false,
  disableSaveButton = false,
  customButtons = [],
  statusLabelText = undefined,
  statusLabelSuccess = false,
  statusLabelSecondary = false,
  customComponent = undefined
}: Props1 | Props2) => {
  const headerClass = `control-header${hasBreadcrumb ? ' control-header--breadcrumb' : ''}`

  return (
    <div class={headerClass}>
      <div class='control-header__texts-container'>
        {
          hasBreadcrumb && (
            <span class='control-header__breadcrumb'>
              <i class='fa fa-chevron-left' />
              <a class='control-header__breadcrumb-link' href={breadcrumbLink}>{breadcrumbText}</a>
            </span>
          )
        }
        <div class='control-header__title'>
          <h2>{title}</h2>
          { statusLabelText && <Flag text={statusLabelText} success={statusLabelSuccess} secondary={statusLabelSecondary} /> }
        </div>
      </div>
      <div class='control-header__buttons'>
        {
          !disableCancelButton && (
            <ButtonControl
              variant='default'
              title='Cancel'
              onClick={() => cancelCallback()}
              class={'js-cancel'}
            />
          )
        }
        {
          !disableSaveButton && (
            <ButtonControl
              variant='success'
              title='Save Changes'
              onClick={() => saveCallback()}
              disabled={isLoading}
              isLoading={isLoading}
              class='js-submit'
            />
          )
        }
        {customButtons && customButtons.map((item) => {
          if (!item) return null
          if (isComponent(item)) return item
          const { url, customClass, variant, title, action } = item
          if (!action && !url) return null

          return (
            <a class='control-header__button-wrapper' href={url}>
              <ButtonControl
                variant={variant}
                class={customClass}
                title={title}
                onClick={action}
              />
            </a>
          )
        })}
      </div>
      {customComponent && customComponent}
    </div>
  )
}

export default Header
